<template>
    <div class="customer-detail-address">
        <el-table border :data="cardList" :size="GCONFIG.styleTableSize">
            <el-table-column label="基本信息">
                <template slot="header" slot-scope="scope">
                    <span>奶卡列表</span>
                </template>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column type="expand" label="展开看详情"  width="100">
                    <template slot-scope="scope">
                        <el-form label-position="left"  class="demo-table-expand">
                            <el-form-item label="卡id">
                                <span>{{ scope.row.cardId }}</span>
                            </el-form-item>

                            <el-form-item label="批次">
                                <span>{{ scope.row.batchName }}</span>
                            </el-form-item>
                            <el-form-item label="卡名称">
                                <span>{{ scope.row.title }}</span>
                            </el-form-item>
                            <el-form-item label="渠道">
                                <span>{{ scope.row.orderSourceName }}</span>
                            </el-form-item>
                            <el-form-item label="购卡订单">
                                <span>{{ scope.row.orderMainNo }}</span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <!--<el-table-column label="卡id" width="180" prop="cardId"></el-table-column>-->
                <!--<el-table-column label="批次" width="180" prop="batchName"></el-table-column>-->
                <el-table-column prop="relateCardNo" label="卡号" width="180"></el-table-column>
                <!--<el-table-column label="卡名称" prop="title" width="100"></el-table-column>-->
                <el-table-column label="卡状态" prop="statusName" width="100"></el-table-column>
                <!--<el-table-column prop="orderSourceName" label="渠道" width="100"></el-table-column>-->
                <el-table-column prop="createTime" label="兑换日期/激活日期" width="180"></el-table-column>
                <el-table-column prop="endTime" label="过期日期" width="180"></el-table-column>
                <el-table-column prop="totalCount" label="总数" width="100"></el-table-column>
                <el-table-column prop="noDeliveryNum" label="待发货" width="100"></el-table-column>
                <el-table-column prop="remainCount" label="未配送" width="100"></el-table-column>
                <el-table-column prop="cardTypeName" label="卡类型" width="100"></el-table-column>
                <el-table-column prop="batchTypeName" label="卡批次类型" width="100"></el-table-column>
                <el-table-column prop="unit" label="配送单位" width="80"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status==2||scope.row.status==5||scope.row.status==6" type="primary" size="mini" @click="handleDetail(scope.row)">查看明细</el-button>
                        <el-button v-if="(scope.row.status==2||scope.row.status==4||scope.row.status==5)&&scope.row.remainCount>0&&(new Date()>new Date(scope.row.endTime)) " type="warning" size="mini" @click="handleExpire(scope.row)">延期</el-button>
                        <el-button v-if="scope.row.status==2||scope.row.status==1" type="danger" size="mini" @click="disabledCard(scope.row)">禁用</el-button>
                    </template>
                </el-table-column>
            </el-table-column>

        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.pageCount"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="设置过期时间" :visible.sync="showDialog">
            <el-form :model="card" :rules="rules" label-width="120px">
                <el-form-item label="过期时间">
                <el-date-picker
                        v-model="card.endTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="设置卡过期时间">
                </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="setCardExpire()">保 存</el-button>
                    <el-button @click="showDialog = false">取 消</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>
<script>
    import {getCarListApi,disabledCardApi,setCardExpireTime} from '@/api/api'
    export default{
        data(){
            return {
                loading: true,
                cardList:[],
                showDialog:false,
                card:{
                    endTime:'',
                    cardId:''
                },
                formInline: {
                    customerId:this.$route.params.id,
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                }
            }
        },
        mounted(){
            this.getCarList()
        },
        methods:{
            getCarList(){
                this.loading=true;
                getCarListApi(this.formInline).then(res=>{
                    this.loading=false;
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.cardList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleDetail(row) {
                this.$router.push({path: '/cardOrderPlan', query: {cardId: row.cardId}})
            },
            handleExpire(row){
                this.showDialog=true;
                this.card.cardId=row.cardId;
                this.card.endTime=row.endTime;
            },
            setCardExpire(){
                this.$confirm('确认, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    setCardExpireTime(this.card).then((res) => {
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getCarList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });
                this.showDialog=false;
            },
            disabledCard(row){
                this.$confirm('确认, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const loading = this.$loading(this.GCONFIG.loadingParam);
                    disabledCardApi({"cardId":row.cardId}).then(res=>{
                        loading.close();
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getCarList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                });

            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCarList();
            },
            handleCurrentChange(val) {
                this.formInline.pageCount = val;
                this.getCarList();
            },
            unableCard(row){
                //禁用卡
            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    .customer-detail-address{
        .header-btn{
            float: right;
        }
        .draw-box{
            padding: 5px;
        }


    }
    .el-drawer__body{
        padding: 5px;
        .el-cascader{
            width: 100%;
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/userSystem/customerCard.vue